import { AnimatePresence, motion } from 'framer-motion'
import PropTypes from 'prop-types'

import AnimatedHeight from './animated-height'
import { DURATION, EASE, VARIANTS } from './tokens'

// Wechsel zwischen Schritten in Dialogen und Panels. Der alte Schritt blendet
// aus, die Höhe gleitet mit, dann blendet der neue ein. Ein neuer stepKey
// startet den Wechsel, Zustände desselben Schritts (z. B. Laden) teilen sich
// einen Key. Innerhalb eines Schritts animiert nichts.
const StepTransition = ({ stepKey, children, className }) => (
  <AnimatedHeight animateKey={stepKey} className={className}>
    <AnimatePresence mode='wait' initial={false}>
      <motion.div
        key={stepKey}
        variants={VARIANTS.fadeUp}
        initial='initial'
        animate='animate'
        exit='exit'
        transition={{ duration: DURATION.base, ease: EASE.standard }}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  </AnimatedHeight>
)

StepTransition.propTypes = {
  stepKey: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string
}

StepTransition.defaultProps = {
  className: undefined
}

export default StepTransition
